import { createAction } from '../../techstyle-shared/redux-core';

export const trackLoginPageView = createAction('login/TRACK_PAGE_VIEW');
export const trackAccountPageView = createAction(
  'login/TRACK_AUTHORIZIED_ACCOUNT_PAGE_VIEW'
);
